import React, { Component } from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import store from "./config/store";
import LoginPage from "./pages/LoginPage";
import PaginaNoEcontrada from "./pages/PaginaNoEncontrada";
import Inicio from "./pages/Inicio";

import Listados from "./pages/Listados";
import ListadoBajas from "./pages/listados/ListadoBajas";
import ListadoAvisos from "./pages/listados/ListadoAvisos";
import ListadoCobros from "./pages/listados/ListadoCobros";
import HistoricoCobros from "./pages/listados/HistoricoCobros";

import ListadoAlumnos from "./pages/listados/ListadoAlumnos";
import DetalleAlumno from "./pages/DetalleAlumno";
import NuevoAlumno from "./pages/NuevoAlumno";

import ListadoColegios from "./pages/listados/ListadoColegios";
import DetalleColegio from "./pages/DetalleColegio";
import NuevoColegio from "./pages/NuevoColegio";

import ListadoActividades from "./pages/listados/ListadoActividades";
import DetalleActividad from "./pages/DetalleActividad";
import NuevaActividad from "./pages/NuevaActividad";

import AsignacionAlumnos from "./pages/AsignacionAlumnos";
import ListadoIncidencias from "./pages/listados/ListadoIncidencias";

import Inscripciones from "./pages/Inscripciones";
import HojaInscripcion from "./pages/inscripciones/HojaInscripcion";
import Preinscripciones from "./pages/Preinscripciones";
import ListaPreinscripciones from "./pages/preinscripciones/ListaPreinscripciones";
import HojaPreinscripcion from "./pages/preinscripciones/HojaPreinscripcion";
import InscripcionesConfirmadas from "./pages/InscripcionesConfirmadas";
import ListaInscripciones from "./pages/inscripcionesConfirmadas/ListaInscripciones";
import InscripcionConfirmada from "./pages/inscripcionesConfirmadas/InscripcionConfirmada";
import AdjuntarDocumentacion from "./pages/AdjuntarDocumentacion";

import Alumnos from "./pages/escuelas/buscadores/Alumnos";
import Colegios from "./pages/escuelas/buscadores/Colegios";
import TablaAsistencias from "./pages/inscripcionesConfirmadas/listaInscripciones/TablaAsistencias";
import Home from "./pages/Home";
import Escuelas from "./pages/Escuelas";

import ProtectedRoute from "./rutas/ProtectedRoute";

/* ########################################################################## */
// Componentes de Colegios
import MasterColegios from "./pages/colegios/MasterColegios";
import MasterColegiosLista from "./pages/colegios/MasterColegiosLista";
import MasterColegiosNuevo from "./pages/colegios/MasterColegiosNuevo";
/* ########################################################################## */

/* ########################################################################## */
// Componentes de Ventas
import Ventas from "./pages/ventas/Ventas";
import VentasNuevaPersonaContacto from "./pages/ventas/VentasNuevaPersonaContacto";
import VentasNuevaTarea from "./pages/ventas/VentasNuevaTarea";
import VentasNuevaCita from "./pages/ventas/VentasNuevaCita";
/* ########################################################################## */

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Router>
          <div>
            <Switch>
              <ProtectedRoute exact path="/" component={Home} />
              <Route path="/login" component={LoginPage} />

              <ProtectedRoute
                path="/extraescolares/inicio"
                component={Inicio}
              />
              <ProtectedRoute
                path="/extraescolares/listados/cobros"
                component={ListadoCobros}
              />
              <ProtectedRoute
                path="/extraescolares/listado/alumnos"
                component={ListadoAlumnos}
              />
              <ProtectedRoute
                path="/extraescolares/listado/colegios"
                component={ListadoColegios}
              />
              <ProtectedRoute
                path="/extraescolares/listado/actividades"
                component={ListadoActividades}
              />
              <ProtectedRoute
                path="/extraescolares/listados"
                component={Listados}
              />

              <ProtectedRoute
                path="/detalle/alumno/:idAlumno"
                component={DetalleAlumno}
              />
              <ProtectedRoute
                path="/detalle/colegio/:idColegio"
                component={DetalleColegio}
              />
              <ProtectedRoute
                path="/detalle/actividad/:idActividad"
                component={DetalleActividad}
              />

              <ProtectedRoute path="/nuevo/alumno" component={NuevoAlumno} />
              <ProtectedRoute path="/nuevo/colegio" component={NuevoColegio} />
              <ProtectedRoute
                path="/nueva/actividad"
                component={NuevaActividad}
              />

              <ProtectedRoute
                path="/asignacionAlumnos/:idColegio"
                component={AsignacionAlumnos}
              />

              <ProtectedRoute path="/escuelas/inicio" component={Escuelas} />
              <ProtectedRoute path="/escuelas/alumnos" component={Alumnos} />
              <ProtectedRoute path="/escuelas/colegios" component={Colegios} />

              <Route path="/inscripciones" component={Inscripciones} />
              <Route path="/hojainscripcion" component={HojaInscripcion} />
              <Route
                path="/adjuntar-documentacion"
                component={AdjuntarDocumentacion}
              />

              <ProtectedRoute path="/listado/bajas" component={ListadoBajas} />
              <ProtectedRoute
                path="/listado/historico-cobros"
                component={HistoricoCobros}
              />
              <ProtectedRoute
                path="/listado/avisos"
                component={ListadoAvisos}
              />
              <ProtectedRoute
                path="/listado/incidencias"
                component={ListadoIncidencias}
              />

              <ProtectedRoute
                exact
                path="/preinscripciones"
                component={Preinscripciones}
              />
              <ProtectedRoute
                exact
                path="/preinscripciones/:idColegio"
                component={ListaPreinscripciones}
              />
              <ProtectedRoute
                exact
                path="/preinscripciones/:idColegio/:idInscripcion"
                component={HojaPreinscripcion}
              />
              <ProtectedRoute
                exact
                path="/inscripciones-confirmadas"
                component={InscripcionesConfirmadas}
              />
              <ProtectedRoute
                exact
                path="/inscripciones-confirmadas/:idColegio"
                component={ListaInscripciones}
              />
              <ProtectedRoute
                exact
                path="/inscripciones-confirmadas/:idColegio/:idInscripcion"
                component={InscripcionConfirmada}
              />
              <Route
                path="/listado/escuelas/control/asistencia"
                component={TablaAsistencias}
              />
              {/* ####################################################### */}
              {/* Rutas de Ventas */}
              <ProtectedRoute
                exact
                path="/ventas/nuevo/contacto/:idColegio"
                component={VentasNuevaPersonaContacto}
              />
              <ProtectedRoute
                exact
                path="/ventas/nuevo/tarea/:idColegio"
                component={VentasNuevaTarea}
              />
              <ProtectedRoute
                exact
                path="/ventas/nuevo/cita/:idColegio"
                component={VentasNuevaCita}
              />
              <ProtectedRoute
                path="/ventas/:opcion/:pagina"
                component={Ventas}
              />
              {/* <ProtectedRoute path="/ventas/tareas" component={VentasTareas} /> */}
              {/* ####################################################### */}

              <ProtectedRoute
                path="/colegios/inicio"
                component={MasterColegios}
              />
              <ProtectedRoute
                path="/colegios/lista"
                component={MasterColegiosLista}
              />
              <ProtectedRoute
                path="/colegios/nuevo"
                component={MasterColegiosNuevo}
              />

              {/* <RutasColegios /> */}

              <Route component={PaginaNoEcontrada} />
            </Switch>
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js